/**
 * Mobile Megamenu Navigation
 * Handles level-based navigation for mobile megamenu
 */

$(document).ready(function () {
    'use strict';

    /**
     * Mobile Megamenu Navigation Handler
     */
    class MobileMegamenuNavigation {
        constructor() {
            this.init();
        }

        init() {
            this.bindEvents();
        }

        bindEvents() {
            // Handle clicks on category expand buttons (show subcategories)
            $(document).on('click', '.mobile-category-expand', (e) => {
                this.handleCategoryExpand(e);
            });

            // Handle clicks on back buttons (return to main categories)
            $(document).on('click', '.mobile-category-back', (e) => {
                this.handleCategoryBack(e);
            });

            // Handle direct clicks on category links
            $(document).on('click', '.mobile-category-link', (e) => {
                this.handleCategoryLinkClick(e);
            });

            // Handle accordion closure to reset navigation
            $(document).on('click', '.mo_ml_level_0 .opener', (e) => {
                this.handleAccordionToggle(e);
            });

            // Handle clicks on menu items that have children (expand/collapse)
            $(document).on('click', '.mo_ml_level_0 .mo_ma_level_0', (e) => {
                this.handleMenuItemClick(e);
            });

            // Handle mobile menu closure (sidebar close)
            $(document).on('click', '.rightbar_tri, .mobile_bar_tri[data-direction="close_bar_right"]', (e) => {
                this.handleMobileMenuClose();
            });

            // Handle clicks outside mobile menu to close
            $(document).on('click', '.st_mobile_stmenu_right_column', (e) => {
                if ($(e.target).hasClass('st_mobile_stmenu_right_column')) {
                    this.handleMobileMenuClose();
                }
            });
        }

        /**
         * Handle category expand button click
         * Shows subcategories for the selected category
         */
        handleCategoryExpand(e) {
            e.preventDefault();
            e.stopPropagation();

            const $button = $(e.currentTarget);
            const categoryId = $button.data('target-category');
            const $navigation = $button.closest('.mobile-mega-menu-navigation');
            const $currentLevel = $navigation.find('.mobile-category-level-1');
            const $targetLevel = $navigation.find(`[data-parent-id="${categoryId}"]`);

            if ($targetLevel.length) {
                this.showLevel($targetLevel, $currentLevel);
            }
        }

        /**
         * Handle back button click
         * Returns to main categories view
         */
        handleCategoryBack(e) {
            e.preventDefault();

            const $button = $(e.currentTarget);
            const $navigation = $button.closest('.mobile-mega-menu-navigation');
            const $currentLevel = $button.closest('.mobile-category-level-2');
            const $targetLevel = $navigation.find('.mobile-category-level-1');

            this.showLevel($targetLevel, $currentLevel);
        }

        /**
         * Handle category link click
         * If category has children, show them instead of navigating
         * Otherwise, let the link work normally
         */
        handleCategoryLinkClick(e) {
            const $link = $(e.currentTarget);
            const $item = $link.closest('.mobile-category-item');
            const hasChildren = $item.data('has-children') === 1;
            const $expandButton = $item.find('.mobile-category-expand');

            // If category has children and expand button exists, prevent link and trigger expand instead
            if (hasChildren && $expandButton.length) {
                e.preventDefault();
                $expandButton.trigger('click');
            }
            // Otherwise, let the link work normally (navigate to category page)
        }

        /**
         * Handle menu item click for items with children
         */
        handleMenuItemClick(e) {
            const $menuItem = $(e.currentTarget);
            const $parentLi = $menuItem.closest('.mo_ml_level_0');
            const $subUl = $parentLi.find('.mo_sub_ul');

            // Check if this is a background image link (should always navigate)
            const isBackgroundImageLink = $menuItem.hasClass('bg-image-link');

            // If it has children and it's not a background image link, toggle accordion
            if ($subUl.length > 0 && !isBackgroundImageLink) {
                e.preventDefault(); // Prevent navigation

                // Trigger the same accordion behavior as clicking the opener
                this.handleAccordionToggle({ currentTarget: $parentLi.find('.opener')[0] || $parentLi[0] });
            }
            // Otherwise, allow normal navigation (do nothing, let the link work)
        }

        /**
 * Handle accordion toggle to reset navigation when closing
 */
        handleAccordionToggle(e) {
            const $opener = $(e.currentTarget);
            const $accordion = $opener.closest('.mo_ml_level_0');
            const $subUl = $accordion.find('.mo_sub_ul');

            // Check if accordion is closing (if it's currently open)
            if ($subUl.is(':visible')) {
                // Remove active state class
                $accordion.removeClass('active');

                // Delay reset to allow accordion animation to complete
                setTimeout(() => {
                    const $navigation = $accordion.find('.mobile-mega-menu-navigation');
                    if ($navigation.length) {
                        this.resetToMainLevel($navigation);
                    }
                }, 300); // Match typical accordion animation duration
            } else {
                // Add active state class
                $accordion.addClass('active');
            }
        }

        /**
         * Handle mobile menu complete closure
         */
        handleMobileMenuClose() {
            // Reset all megamenu navigations when mobile menu closes
            setTimeout(() => {
                $('.mobile-mega-menu-navigation').each((index, element) => {
                    this.resetToMainLevel($(element));
                });

                // Remove all open state classes
                $('.mo_ml_level_0').removeClass('st_open');
            }, 100); // Small delay to ensure menu is closing
        }

        /**
         * Show target level and hide current level using direct display control
         */
        showLevel($targetLevel, $currentLevel) {
            // Hide current level
            if ($currentLevel && $currentLevel.length) {
                $currentLevel.hide();
            }

            // Show target level
            if ($targetLevel && $targetLevel.length) {
                $targetLevel.show();
            }
        }

        /**
         * Reset all levels to initial state (show level 1)
         */
        resetToMainLevel($navigation) {
            const $level1 = $navigation.find('.mobile-category-level-1');
            const $level2 = $navigation.find('.mobile-category-level-2');

            $level2.hide();
            $level1.show();
        }
    }

    // Initialize mobile megamenu navigation
    new MobileMegamenuNavigation();
}); 